
export default function PriceHighlights() {
  const prices = [
    {
      service: 'Cetak Foto 3R',
      price: 'Mulai 2.000',
      icon: 'ri-image-line',
      color: 'from-blue-500 to-blue-600'
    },
    {
      service: 'Install Ulang Laptop',
      price: 'Mulai 60.000',
      icon: 'ri-computer-line',
      color: 'from-purple-500 to-purple-600'
    },
    {
      service: 'Pasang CCTV (Jasa)',
      price: 'Mulai 150.000',
      icon: 'ri-webcam-line',
      color: 'from-green-500 to-green-600'
    },
    {
      service: 'Cetak Stiker A3',
      price: 'Mulai 15.000',
      icon: 'ri-sticky-note-line',
      color: 'from-orange-500 to-orange-600'
    },
    {
      service: 'Undangan Digital Website',
      price: 'Mulai 35.000',
      icon: 'ri-global-line',
      color: 'from-pink-500 to-pink-600'
    },
    {
      service: 'Jam Digital Masjid',
      price: 'Mulai 350.000',
      icon: 'ri-time-line',
      color: 'from-teal-500 to-teal-600'
    },
    {
      service: 'Servis Sepeda Listrik',
      price: 'Mulai 20.000',
      icon: 'ri-e-bike-2-line',
      color: 'from-yellow-500 to-yellow-600'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-[#0B1F3B] to-[#0d2847] relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-10 right-10 w-64 h-64 bg-[#FF8A00] rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 left-10 w-96 h-96 bg-[#FF8A00] rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="text-[#FF8A00] font-semibold text-sm uppercase tracking-wider bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full">
              Harga Terjangkau
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Harga Spesial untuk Anda
          </h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto">
            Layanan berkualitas dengan harga yang bersahabat
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-12">
          {prices.map((item, index) => (
            <div
              key={index}
              className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20 hover:bg-white/20 hover:border-[#FF8A00] transition-all duration-300 hover:scale-105"
            >
              <div className={`w-16 h-16 flex items-center justify-center bg-gradient-to-br ${item.color} rounded-xl mb-4`}>
                <i className={`${item.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-white font-semibold text-lg mb-2">
                {item.service}
              </h3>
              <div className="flex items-baseline gap-1">
                <span className="text-[#FF8A00] text-2xl font-bold">Rp</span>
                <span className="text-[#FF8A00] text-3xl font-bold">
                  {item.price.replace('Mulai ', '')}
                </span>
              </div>
              <p className="text-gray-400 text-sm mt-1">per layanan</p>
            </div>
          ))}
        </div>

        <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-6 max-w-3xl mx-auto">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 flex items-center justify-center bg-[#FF8A00] rounded-xl flex-shrink-0">
              <i className="ri-information-line text-2xl text-white"></i>
            </div>
            <div>
              <h4 className="text-white font-semibold text-lg mb-2">Catatan Penting</h4>
              <p className="text-gray-300 text-sm leading-relaxed">
                Harga dapat berubah sesuai kondisi dan permintaan. Silakan hubungi kami untuk detail lengkap dan penawaran terbaik untuk kebutuhan Anda.
              </p>
            </div>
          </div>
        </div>

        <div className="text-center mt-12">
          <a
            href="https://wa.me/6285868360910"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-[#25D366] hover:bg-[#20bd5a] text-white px-8 py-4 rounded-full font-semibold text-lg transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-fill text-2xl"></i>
            Tanya Harga Sekarang
            <i className="ri-arrow-right-line text-xl"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
